export default __webpack_public_path__ + "static/Nael-a0c7d024af49a152df81a5e0b8cd5607.jpg";